import { type EditorPlugin } from '../../types/aha-editor';
import { type Editor, type NodeEntry, Text, Transforms } from 'slate';
import { isLinkElement } from '../../types/guards';

// Normalize link elements.
// 1. A link with no visible text should be removed since the user can no longer
//    easily navigate it, and it can't be clicked.
const LinkNormalizationPlugin: EditorPlugin = {
  name: 'Link normalization plugin',
  normalization: {
    type: 'link',
    run: (editor: Editor, entry: NodeEntry) => {
      const [node, path] = entry;

      if (!isLinkElement(node)) return;

      if (
        node.children.length === 1 &&
        Text.isText(node.children[0]) &&
        node.children[0].text === ''
      ) {
        Transforms.removeNodes(editor, { at: path });
        return true;
      }
    },
  },
};

export default LinkNormalizationPlugin;
